import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Terms from "../pages/terms/page";
import Privacy from "../pages/privacy/page";
import Refund from "../pages/refund/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/refund",
    element: <Refund />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
